import { render, staticRenderFns } from "./BatteryStatus.vue?vue&type=template&id=15c6e29e&scoped=true&"
import script from "./BatteryStatus.vue?vue&type=script&lang=js&"
export * from "./BatteryStatus.vue?vue&type=script&lang=js&"
import style0 from "./BatteryStatus.vue?vue&type=style&index=0&id=15c6e29e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6e29e",
  null
  
)

export default component.exports